var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.categoryProps === _vm.config.rootcategories.drukowanie
      ? _c(
          "div",
          {
            staticClass:
              "mb15 capitalize cl-mine-shaft available-status available-setting_rwd",
            class: {
              center: _vm.align === "center",
              left: _vm.align === "left",
              right: _vm.align === "right"
            }
          },
          [
            _vm._v("\n    " + _vm._s(_vm.$t("available")) + ":\n    "),
            _c("span", { staticClass: "available-dots" }, [
              _c("span", {
                staticClass: "available-dot",
                class: { active: _vm.getProductQty >= 1 }
              }),
              _vm._v(" "),
              _c("span", {
                staticClass: "available-dot",
                class: { active: _vm.getProductQty > 10 }
              }),
              _vm._v(" "),
              _c("span", {
                staticClass: "available-dot",
                class: { active: _vm.getProductQty > 20 }
              }),
              _vm._v(" "),
              _c("span", {
                staticClass: "available-dot",
                class: { active: _vm.getProductQty > 30 }
              })
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.categoryProps === _vm.config.rootcategories.biuro
      ? _c(
          "div",
          {
            staticClass: "mb15 capitalize cl-mine-shaft available-status",
            class: {
              center: _vm.align === "center",
              left: _vm.align === "left",
              right: _vm.align === "right"
            }
          },
          [_vm._v("\n    " + _vm._s(_vm.showAvailability) + "\n  ")]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }